var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdobeStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "st_x5F_cc_x5F_app_x5F_RGB.svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240 234",
    style: {
      enableBackground: "new 0 0 240 234"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E000A"
    },
    width: 220,
    height: 213.999
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF4475"
    },
    d: "M0,0v233.999h240.001V0H0z M10,10h220.001v213.999H10V10z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF4475"
    },
    d: "M60.99,158.802c-0.66-0.494-0.99-1.154-0.99-2.145v-15.84 c0-0.496,0.66-0.99,1.32-0.496c7.425,5.115,16.104,7.426,24.354,7.426c12.045,0,16.995-6.27,16.995-13.365 c0-6.27-3.135-11.385-14.685-18.15l-5.94-3.135C65.05,103.527,60.1,93.793,60.1,81.418c0-16.83,11.715-30.36,33.825-30.36 c9.735,0,16.96,1.485,21.085,3.795c0.825,0.33,0.99,0.825,0.99,1.815v14.85c0,0.66-0.66,1.154-1.32,0.66 c-5.115-3.301-12.67-4.95-20.425-4.95c-12.705,0-16.83,7.26-16.83,13.035c0,6.27,3.135,10.89,14.52,17.159l5.28,2.806 c18.81,10.396,23.595,20.459,23.595,32.834c0,18.314-13.365,31.02-35.145,31.02C75.94,164.081,67.094,162.267,60.99,158.802z  M175.5,160.287c0,0.826-0.33,1.486-1.156,1.816c-3.465,1.318-7.26,1.979-12.209,1.979c-12.541,0-19.635-6.6-19.635-22.109V97 h-9.487c-0.825,0-1.013-0.33-1.013-1.155V82.57c0-0.825,0.165-1.32,1.155-1.32h9.487c0.166-5.775,0.826-15.84,1.485-18.975 c0-1.155,0.496-1.482,1.154-1.648l14.852-1.979c0.66-0.165,1.154-0.003,1.154,0.822c-0.33,4.785-0.494,12.87-0.66,21.78h14.467 c0.826,0,1.156,0.33,1.156,1.155V96.01c0,0.825-0.496,0.99-1.156,0.99H160.5v41.91c0,6.766,2.311,9.828,8.414,9.828 c1.981,0,3.615-0.166,5.596-0.66c0.494-0.166,0.99,0.164,0.99,0.99V160.287z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeStock);
export default __webpack_public_path__ + "static/media/adobe-stock.cf6db207cc3447c34a9f8499666f3e05.svg";
export { ForwardRef as ReactComponent };